import { render } from "./KizingoKids.vue?vue&type=template&id=2d9f2de4"
import script from "./KizingoKids.vue?vue&type=script&lang=js"
export * from "./KizingoKids.vue?vue&type=script&lang=js"

import "./KizingoKids.vue?vue&type=style&index=0&id=2d9f2de4&lang=scss"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__